import React from 'react';
import baseIcons from '@/shared/assets/sprites/base.sprite.svg';
interface Props {
  address: string;
}
export const AddressMedcenter: React.FC<Props> = ({
  address
}) => {
  return <address className="flex items-center gap-1" data-sentry-component="AddressMedcenter" data-sentry-source-file="AddressMedcenter.tsx">
      <svg className="size-6 fill-current text-textPrimary" data-sentry-element="svg" data-sentry-source-file="AddressMedcenter.tsx">
        <use xlinkHref={`${baseIcons}#location`} data-sentry-element="use" data-sentry-source-file="AddressMedcenter.tsx"></use>
      </svg>

      <span className="text-lg font-bold">{address}</span>
    </address>;
};